import axios from "axios";

const API = "/api";
const auth = () => {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

/** Chamadas da tela Anúncios Meta (backend/api/v1/meta_ads). */
export const anunciosMetaApi = {
  situacao: () => axios.get(`${API}/meta-ads/situacao`, auth()).then((r) => r.data),
  ativos: (business_id) =>
    axios.post(`${API}/meta-ads/conexao/ativos`, { business_id }, auth()).then((r) => r.data),
  conectar: (dados) => axios.post(`${API}/meta-ads/conexao`, dados, auth()).then((r) => r.data),
  desconectar: () => axios.delete(`${API}/meta-ads/conexao`, auth()).then((r) => r.data),
  salvarLocalizacao: (dados) => axios.put(`${API}/meta-ads/localizacao`, dados, auth()).then((r) => r.data),
  geocodificar: () => axios.post(`${API}/meta-ads/localizacao/geocodificar`, {}, auth()).then((r) => r.data),
  salvarImposto: (imposto_pct) => axios.put(`${API}/meta-ads/imposto`, { imposto_pct }, auth()).then((r) => r.data),
  campanhas: (dias) => axios.get(`${API}/meta-ads/campanhas?dias=${dias}`, auth()).then((r) => r.data),
  sincronizar: () => axios.post(`${API}/meta-ads/sincronizar`, {}, auth()).then((r) => r.data),
  // O link "Anúncios Meta" de Links de divulgação: criar de novo devolve o mesmo.
  gerarLink: () => axios.post(`${API}/sms/links-divulgacao/meta_ads`, {}, auth()).then((r) => r.data),

  // ---- Impulsionar pelo Núcleo (fase 4) ----
  dadosDoAssistente: () => axios.get(`${API}/meta-ads/impulsionar/dados`, auth()).then((r) => r.data),
  alcance: (dados) => axios.post(`${API}/meta-ads/impulsionar/alcance`, dados, auth()).then((r) => r.data),
  enviarImagem: (arquivo) => {
    const corpo = new FormData();
    corpo.append("file", arquivo);
    return axios.post(`${API}/meta-ads/impulsionar/imagem`, corpo, auth()).then((r) => r.data);
  },
  // Devolve a resposta inteira: 202 = outra chamada com a mesma chave ainda está publicando.
  publicar: (pedido) => axios.post(`${API}/meta-ads/impulsionar`, pedido, { ...auth(), timeout: 120000 }),
  cartoes: () => axios.get(`${API}/meta-ads/impulsionar/campanhas`, auth()).then((r) => r.data),
  acaoDaCampanha: (id, acao) => axios.post(`${API}/meta-ads/impulsionar/campanhas/${id}/${acao}`, {}, auth()).then((r) => r.data),
  mudarOrcamento: (id, orcamento_semanal_centavos) =>
    axios.put(`${API}/meta-ads/impulsionar/campanhas/${id}/orcamento`, { orcamento_semanal_centavos }, auth()).then((r) => r.data),
  mudarPeriodo: (id, dados) => axios.put(`${API}/meta-ads/impulsionar/campanhas/${id}/periodo`, dados, auth()).then((r) => r.data),
  mudarHorario: (id, horario_modo) => axios.put(`${API}/meta-ads/impulsionar/campanhas/${id}/horario`, { horario_modo }, auth()).then((r) => r.data),
  novoAnuncio: (id, anuncio) => axios.post(`${API}/meta-ads/impulsionar/campanhas/${id}/anuncios`, anuncio, { ...auth(), timeout: 120000 }).then((r) => r.data),
  acaoDoAnuncio: (id, anuncioId, acao) =>
    axios.post(`${API}/meta-ads/impulsionar/campanhas/${id}/anuncios/${anuncioId}/${acao}`, {}, auth()).then((r) => r.data),
  avisos: () => axios.get(`${API}/meta-ads/avisos`, auth()).then((r) => r.data),
  marcarAvisosLidos: () => axios.post(`${API}/meta-ads/avisos/lidos`, {}, auth()).then((r) => r.data),
};

/** Mensagem de erro segura para toast (422 do FastAPI vem como lista). */
export function mensagemDeErro(erro, padrao) {
  const d = erro?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join("; ") || padrao;
  return padrao;
}

export const reais = (centavos) =>
  (Number(centavos || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Valor com o imposto que a Meta repassa — a mesma conta do servidor (`cartoes._com_imposto`). */
export const comImposto = (centavos, pct) => Math.round(Number(centavos || 0) * (1 + Number(pct || 0) / 100));

export const km = (valor) => `${Number(valor || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} km`;

export const dataHoraBR = (iso) =>
  (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

const soNumeros = (id) => String(id || "").replace(/\D/g, "");

/** Telas da Meta para a conta conectada: onde recarregar e onde ficam os anúncios. */
export const urlRecarga = (c) =>
  `https://business.facebook.com/billing_hub/payment_settings?asset_id=${soNumeros(c?.ad_account_id)}&business_id=${soNumeros(c?.business_id)}`;
export const urlGerenciador = (c) =>
  `https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=${soNumeros(c?.ad_account_id)}&business_id=${soNumeros(c?.business_id)}`;

export const dataBR = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) : "—");

/** Foto de produto ou imagem do anúncio guardada no servidor (`/uploads/...`). */
export const urlImagem = (caminho) => (!caminho ? null : /^https?:\/\//.test(caminho) ? caminho : `/api${caminho.startsWith("/") ? caminho : `/${caminho}`}`);

export const ROTA_RELATORIO = "/admin/relatorios/anuncios-meta";
export const ROTA_ANUNCIOS = "/admin/impulsione/anuncios-meta";
export const ROTA_IMPULSIONAR = "/admin/impulsione/anuncios-meta/impulsionar";
export const rotaNovoAnuncio = (campanhaId) => `/admin/impulsione/anuncios-meta/campanha/${encodeURIComponent(campanhaId)}/anuncio`;
export const rotaRelatorioDaCampanha = (campanhaId) => `${ROTA_RELATORIO}/${encodeURIComponent(campanhaId)}`;
